var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "platform-selector-inline" },
    [
      _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          attrs: { mode: _vm.multiple ? "multiple" : "default" },
          model: {
            value: _vm.selectedPlatform,
            callback: function ($$v) {
              _vm.selectedPlatform = $$v
            },
            expression: "selectedPlatform",
          },
        },
        _vm._l(_vm.platforms, function (option) {
          return _c(
            "a-select-option",
            {
              key: option,
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { value: option },
            },
            [
              _c(
                "div",
                { staticClass: "option-wrapper" },
                [
                  option === "supsis"
                    ? _c("SupsisIcon", {
                        staticClass: "option-icon",
                        attrs: { color: "#25D366" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "whatsapp"
                    ? _c("WhatsappIcon", {
                        staticClass: "option-icon",
                        attrs: { color: "#25D366" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "telegram"
                    ? _c("TelegramIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "messenger"
                    ? _c("MessengerIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "web"
                    ? _c("webIcon", {
                        staticClass: "option-icon",
                        attrs: { color: "black;" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "email"
                    ? _c("mailIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "meta-leads"
                    ? _c("MetaIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "trendyol"
                    ? _c("TrendyolIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "linkedin"
                    ? _c("LinkedinIcon", { staticClass: "option-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "instagram"
                    ? _c("InstagramIcon", {
                        staticClass: "option-icon",
                        attrs: { "special-background-mode": "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  option === "calendar"
                    ? _c("span", { staticClass: "md-icon" }, [
                        _vm._v("calendar_month"),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.platformName[option]) +
                      "\n            "
                  ),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }